import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const alertItemDefaultVariants = {}
const alertItemCompoundVariants = []

const alertItemSlotNames = [
  [
    "root",
    "alert-item__root"
  ],
  [
    "text",
    "alert-item__text"
  ]
]
const alertItemSlotFns = /* @__PURE__ */ alertItemSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, alertItemDefaultVariants, getSlotCompoundVariant(alertItemCompoundVariants, slotName))])

const alertItemFn = memo((props = {}) => {
  return Object.fromEntries(alertItemSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const alertItemVariantKeys = []
const getVariantProps = (variants) => ({ ...alertItemDefaultVariants, ...compact(variants) })

export const alertItem = /* @__PURE__ */ Object.assign(alertItemFn, {
  __recipe__: false,
  __name__: 'alertItem',
  raw: (props) => props,
  variantKeys: alertItemVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, alertItemVariantKeys)
  },
  getVariantProps
})